document.addEventListener("DOMContentLoaded", function () {
  function setVideoHeight() {
    let getBanner = document.querySelector(".announcement-bar");
    let bannerHeight = 0;

    if (getBanner) {
      bannerHeight = 30;
    }

    if (window.innerWidth < 600) {
      let trueHeight = window.innerHeight - bannerHeight - 65;
      let setHeights = document.querySelectorAll(".video-height");
      setHeights.forEach(function (item) {
        item.style.height = trueHeight + "px";
      });
      console.log("Set video height to " + trueHeight + "px");
    }
  }

  setVideoHeight();
  //window.addEventListener("resize", setVideoHeight);

  let videoBlock = document.querySelector(".video");
  if (videoBlock) {
    let video = videoBlock.querySelector("video");
    //let playBtn = videoBlock.querySelector('.play-btn');
    let muteBtn = videoBlock.querySelector(".mute-btn");

    muteBtn.addEventListener("click", (event) => {
      event.preventDefault();
      //console.log("Mute");
      if (video.muted) {
        video.muted = false;
        video.volume = 0.5;
        muteBtn.querySelector("img").src =
          "https://cdn.shopify.com/s/files/1/0024/3918/4502/files/sound-on.svg?v=1732044538";
        //muteBtn.textContent = 'Sound Off';
      } else {
        video.muted = true;
        muteBtn.querySelector("img").src =
          "https://cdn.shopify.com/s/files/1/0024/3918/4502/files/sound-off.svg?v=1732044539";
        //muteBtn.textContent = 'Sound On';
      }
    });

    //muteBtn.click();
  }

  let shoeSwiper = document.querySelector(".shoes-swiper");

  if (shoeSwiper) {
    new Swiper(shoeSwiper, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      scrollbar: {
        el: ".swiper-scrollbar"
      },
      breakpoints: {
        650: {
          slidesPerView: 3,
          spaceBetween: 2,
        },
      },
    });
  }

  let tripleSwiper = document.querySelector(".triple-swiper");

  if (tripleSwiper) {
    new Swiper(tripleSwiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 1,
      //loop: true,
      breakpoints: {
        650: {
          slidesPerView: 3,
          spaceBetween: 20,
          initialSlide: 0
        },
      },
    });
  }

  let homeSwipers = document.querySelectorAll(".collection-swiper");

  if (homeSwipers.length > 0) {
    homeSwipers.forEach((homeSwiper) => {
      new Swiper(homeSwiper, {
        //preloadImages: false,
        loop: true,
        slidesPerView: 2,
        spaceBetween: 2,
        draggable: true,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        //spaceBetween: 24,
        wrapperClass: "collection-wrapper",
        slideClass: "collection-slide",

        // autoplay: {
        //   delay: 0, // 0 delay for continuous movement
        //   disableOnInteraction: false,
        // },
        // speed: 4000,

        navigation: {
          nextEl: ".arrows .right",
          prevEl: ".arrows .left",
        },
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 2,
          },
          880: {
            slidesPerView: 3,
            spaceBetween: 2,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 2,
          },
        },
        on: {
          init: function () {
            // Add class to all slides inside this Swiper instance
            this.slides.forEach((slide) => {
              slide.classList.add("finished-loading");
            });
          },
        },
      });
    });
  }

  let heroSwipers = document.querySelectorAll(".hero-swiper");

  if (heroSwipers.length > 0) {
    let trueHeight = window.innerHeight;
    let setHeights = document.querySelectorAll(".auto-height");
    setHeights.forEach(function (item, i) {
      item.style.height = trueHeight + "px";
    });

    heroSwipers.forEach((heroSwiper) => {
      let trueHeight = window.innerHeight;
      let subtractHeader = 65;
      let getBanner = document.querySelector(".announcement-bar");
      if (getBanner) {
        subtractHeader += 30;
      }

      if (window.innerWidth <= 850) {
        heroSwiper.style.height = trueHeight - subtractHeader + "px";
      }

      new Swiper(heroSwiper, {
        allowTouchMove: false, // disable swipe/drag/touch completely
        simulateTouch: false, // ensure no mouse drag events either
        freeMode: false, // keeps autoplay smooth and linear
        loop: true,
        autoplay: {
          delay: 0, // continuous
          disableOnInteraction: false, // keep autoplay running no matter what
          pauseOnMouseEnter: false, // do not pause on hover
        },
        speed: 12000,
        slidesPerView: "auto",

        breakpoints: {
          1200: {
            speed: 8500,
          },
        },
      });
    });
  }

  let doubleSwipers = document.querySelectorAll(".double-swiper");

  if (doubleSwipers.length > 0) {
    doubleSwipers.forEach((doubleSwiper) => {
      // 1. Look inside this specific swiper for pagination and navigation elements
      const paginationEl = doubleSwiper.querySelector(".swiper-pagination");
      const nextEl = doubleSwiper.querySelector(".swiper-button-next");
      const prevEl = doubleSwiper.querySelector(".swiper-button-prev");

      // 2. Create an empty object to hold all the settings for this swiper
      const swiperOptions = {};

      // 3. Enable looping (this makes the slides go back to the first after the last)
      swiperOptions.loop = true;

      // 4. If the pagination element exists, add pagination settings
      if (paginationEl) {
        swiperOptions.pagination = {
          el: paginationEl,
          type: "fraction",
          renderFraction: function (currentClass, totalClass) {
            return (
              '<span class="' +
              currentClass +
              '"></span>' +
              "<span class='divider'>-</span>" +
              '<span class="' +
              totalClass +
              '"></span>'
            );
          },
        };
      }

      // 5. If both next and previous buttons exist, add navigation settings
      if (nextEl && prevEl) {
        swiperOptions.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }

      // 6. Finally, create the Swiper instance with all the options
      new Swiper(doubleSwiper, swiperOptions);
    });
  }

  function handleCategoryHover() {
    let categoryMainImage = document.querySelector("#category-image");
    let categoryImages = document.querySelectorAll(".category-list li a");

    if (window.innerWidth > 850) {
      categoryImages.forEach((categoryLink) => {
        categoryLink.addEventListener("mouseover", (event) => {
          event.preventDefault();
          let currentImageSrc = categoryLink.getAttribute("data-img");
          categoryMainImage.src = currentImageSrc;
        });
      });
    } else {
      categoryImages.forEach((categoryLink) => {
        categoryLink.removeEventListener("mouseover", () => {});
      });
    }
  }

  handleCategoryHover();
  window.addEventListener("resize", handleCategoryHover);

  let singleSwipers = document.querySelectorAll(".single-swiper");

  if (singleSwipers.length > 0) {
    singleSwipers.forEach((singleSwiper) => {
      new Swiper(singleSwiper, {
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: false,
        },
        allowTouchMove: false,
        speed: 10, // instant switch, no visible fade
        autoplay: {
          delay: 1500, // how long each image stays on screen
          disableOnInteraction: false,
        },
      });
      
    });
  }


});
